import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { GA4TryButtonClickEvent, GTMBaseEvent, GtmEventType } from './gtmEventType';

type GTMTryButtonEvent = {
    button: {
        value?: string;
        type?: string;
        callToAction: {
            label: string;
            name: string;
        };
    };
    title?: string;
    url: string;
    listingFlow?: string;
    contentCategory?: string;
    elementTitle?: string;
    internalDriver?: string;
    clickText: string;
} & GTMBaseEvent;

export type GTMClickEvent = GTMTryButtonEvent;
export const tryButton = 'try button';
export class GtmTryButtonClickType extends GtmEventType {
    canHandle(event: GTMBaseEvent): boolean {
        return (
            (event.topic === AnalyticsEventTopic.ANALYTICS_USER_ACTIVITY ||
                event.topic === AnalyticsEventTopic.ANALYTICS_USER_INSTALL ||
                event.topic === AnalyticsEventTopic.ANALYTICS_CLICK) &&
            event.elementType === tryButton
        );
    }

    getBody(event: GTMTryButtonEvent): GA4TryButtonClickEvent {
        const { url, contentCategory, elementTitle, listingFlow, clickText, internalDriver } = event;
        return {
            event: 'custEv_tryFreeCTAClick',
            click_url: url,
            ctaClick: true,
            content_category: contentCategory || '',
            click_text: clickText,
            element_title: elementTitle || '',
            listing_flow: listingFlow || '',
            element_type: 'button',
            internal_driver: internalDriver || '',
        };
    }
}
